var a={AUDIT:"audit"};export{a as Pages,a as default};
//# sourceMappingURL=pages.js.map